var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '../../lib/dom';
import { OrangeButton } from '../../lib/components/Button/Button';
import { PHRASES, t } from '../../translate';
import { emitter } from '../../app';
import './StartScreen.less';
var StartScreen = /** @class */ (function (_super) {
    __extends(StartScreen, _super);
    function StartScreen(props) {
        var _this = _super.call(this, props) || this;
        _this.name = 'StartScreen';
        var _a = _this.props, preview = _a.preview, onContinue = _a.onContinue, onStartNew = _a.onStartNew;
        _this.el = _this.DIV('&', [
            (_this.title = _this.DIV('&-title', [IS_ULTRA ? TITLE : t(PHRASES.Block_Puzzle)])),
            (_this.preview = _this.DIV('&-preview-w', [preview])),
            _this.DIV('&-buttons', [
                (_this.btn1 = new OrangeButton({ onClick: onStartNew }, [t(PHRASES.New_Game)])),
                (_this.btn2 = new OrangeButton({ className: 'AnimatedButton', onClick: onContinue }, [t(PHRASES.Continue)])),
            ]),
        ]);
        emitter.on('lang', function () {
            _this.title.html(IS_ULTRA ? TITLE : t(PHRASES.Block_Puzzle));
            _this.btn1.html = t(PHRASES.New_Game);
            _this.btn2.html = t(PHRASES.Continue);
        });
        return _this;
    }
    StartScreen.prototype.setPreview = function (preview) {
        this.preview.html('');
        this.preview.valueOf().appendChild(preview);
    };
    StartScreen.prototype.resize = function () {
        var rect = this.preview.valueOf().getBoundingClientRect();
        if (rect && rect.height > 0) {
            var maxHeight = window.innerHeight - 150;
            var ratio = rect.width / rect.height;
            var maxWidth = Math.ceil(maxHeight * ratio);
            this.preview.css('maxWidth', "".concat(interval(maxWidth, 100, 400), "px"));
        }
    };
    return StartScreen;
}(Component));
export { StartScreen };
function interval(maxWidth, min, max) {
    return Math.max(min, Math.min(max, maxWidth));
}
